var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoussole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.793 24.5H24.8134M43.168 24.5C43.168 34.6482 34.9412 42.875 24.793 42.875C14.6447 42.875 6.41797 34.6482 6.41797 24.5C6.41797 14.3518 14.6447 6.125 24.793 6.125C34.9412 6.125 43.168 14.3518 43.168 24.5ZM32.9596 16.3333L19.6888 19.3958L16.6263 32.6667L29.8971 29.6042L32.9596 16.3333Z",
    stroke: "url(#paint0_linear_1127_28170)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1127_28170",
    x1: 6.41797,
    y1: 42.875,
    x2: 43.168,
    y2: 42.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21639E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoussole);
export default __webpack_public_path__ + "static/media/boussole.9cd4db04bae5d68283e6a023bd3057d5.svg";
export { ForwardRef as ReactComponent };